import { render, staticRenderFns } from "./FacebookProfileDetails.vue?vue&type=template&id=2a007390&scoped=true&"
import script from "./FacebookProfileDetails.vue?vue&type=script&lang=ts&"
export * from "./FacebookProfileDetails.vue?vue&type=script&lang=ts&"
import style0 from "./FacebookProfileDetails.vue?vue&type=style&index=0&id=2a007390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a007390",
  null
  
)

export default component.exports